import { Box, SxProps, type Theme } from '@mui/material';
import { Tag } from '@care/react-component-lib';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_jobSearchResults_seoSegmentationJob as SEOJob } from '@/__generated__/seoSegmentationListingPage';
import { createJobTagList } from './helpers/createJobTagList';

export interface JobTagListProps {
  job: SEOJob;
  sx?: SxProps<Theme>;
}

export const JobTagList = ({ job, sx }: JobTagListProps) => {
  const {
    city,
    state,
    type,
    job: { startDate, hourlyRateRange },
  } = job;

  const tagList = createJobTagList({
    type,
    hourlyRateRange,
    startDate,
    city,
    state,
  });
  return (
    <Box sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      {tagList.map((tag) => (
        <Tag type="grey" sx={{ mr: 1 }} key={tag}>
          {tag}
        </Tag>
      ))}
    </Box>
  );
};
